import SectionForm, { useFormContext } from "../SectionForm"
import { Input, Toggle } from '@/components/ui'

const FieldList = [
  // Partie 1
  {name: "assurance_proprietaire", label: "Assurance propriétaire", type: "toggle"},
  {name: "assurance_locataire", label: "Assurance locataire", type: "toggle"},
  // Partie 2 - Dates de dernier relevé
  {name: "assurance_proprietaire_date_dernier_releve", 
    label: "Date du dernier relevé d'assurance propriétaire", type: "date"},
  {name: "assurance_locataire_date_dernier_releve", 
    label: "Date du dernier relevé d'assurance locataire", type: "date"},
  // Partie 3 - Dates d'échéance
  {name: "assurance_proprietaire_date_echeance", 
    label: "Date d'échéance assurance propriétaire", type: "date"},
  {name: "assurance_locataire_date_echeance", 
    label: "Date d'échéance assurance locataire", type: "date"},
]

const FormContent = () => {
  const { control, getValues, watch, formState: {errors: formErrors} } = useFormContext()
  const typeBien = getValues("type_bien")
  const immeubleId = getValues("immeuble_id")
  
  // Watcher pour les dates d'assurance afin de déclencher la revalidation
  watch("assurance_proprietaire_date_dernier_releve")
  watch("assurance_locataire_date_dernier_releve")
  return (
    <>
      <div className="flex flex-col items-center gap-6 pt-2">
        { immeubleId ? <div className="min-h-3"></div> :
          <Toggle.Form name="assurance_proprietaire"
            label="Assurance propriétaire"
            control={control}
            className='w-full ms-3 ps-3'
          />
        }
        { typeBien !== "immeuble" && (
          <Toggle.Form name="assurance_locataire"
            label="Assurance locataire"
            control={control}
            className='w-full ms-3 ps-3'
          />
        )}
      </div>
      <div className="flex flex-col items-center gap-4 col-span-2"> 
        { immeubleId ? <div className="min-h-3"></div> :
          <>
            <Input.Date 
                name="assurance_proprietaire_date_dernier_releve"
                control={control}
                label="Date du dernier relevé d'assurance propriétaire"
                className='w-3/4'
            />
            <Input.Date 
                name="assurance_proprietaire_date_echeance"
                control={control}
                label="Date d'échéance assurance propriétaire"
                className='w-3/4'
                rules={{
                  validate: (value) => {
                    const dateReleve = getValues("assurance_proprietaire_date_dernier_releve")
                    if (dateReleve && !value) {
                      return "Date d'échéance obligatoire si une date de dernier relevé est saisie"
                    }
                    return true
                  }
                }}
                validator={{
                  hasError: (fieldName) => !!formErrors?.[fieldName],
                  getErrorMessage: (fieldName) => formErrors?.[fieldName]?.message || ''
                }}
            />
          </>
        }
        { typeBien !== "immeuble" && (
          <>
            <Input.Date 
                name="assurance_locataire_date_dernier_releve"
                control={control}
                label="Date du dernier relevé d'assurance locataire"
                className='w-3/4'
            />
            <Input.Date 
                name="assurance_locataire_date_echeance"
                control={control}
                label="Date d'échéance assurance locataire"
                className='w-3/4'
                rules={{
                  validate: (value) => {
                    const dateReleve = getValues("assurance_locataire_date_dernier_releve")
                    if (dateReleve && !value) {
                      return "Date d'échéance obligatoire si une date de dernier relevé est saisie"
                    }
                    return true
                  }
                }}
                validator={{
                  hasError: (fieldName) => !!formErrors?.[fieldName],
                  getErrorMessage: (fieldName) => formErrors?.[fieldName]?.message || ''
                }}
            />
          </>
        )}
       </div>
    </>
  )
}

 export default ({ title = "", onClose = () => {}, onSuccess = () => {} }) => (
  <SectionForm
    title={title}
    onClose={onClose}
    onSuccess={onSuccess}
    fields={FieldList.map( f => f.name)}
  >
    <FormContent />
  </SectionForm>
)